import AddIcon from '@mui/icons-material/Add';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import _ from 'lodash';
import React, { useMemo } from 'react';
import { useGetAllPreferences } from '../../services/react-query/preferences';
import { listPageTableRowStyling } from '../../styles/sxStyling';
import { Contact } from '../../types/Contact';
import { PREFERENCES_VALID_KEYS } from '../../types/Preference';
import { UserConfigurableModule, UserSettingsCollapseKeys } from '../../types/User';
import ResponsiveButton from '../../uikit/buttons/ResponsiveButton';
import AccordionSection from '../AccordionSection';
import DrawerLink from '../common/drawers/ModuleDrawer/DrawerLink';
import PreferencesPopover from '../common/popover/PreferencesPopover';

interface AccountContactTableProps {
  contacts: Contact[];
  handleCreateContact: () => void;
}

const AccountContactTable = ({ contacts, handleCreateContact }: AccountContactTableProps) => {
  const { data: preferenceData } = useGetAllPreferences({
    params: {
      filters: { keys: [PREFERENCES_VALID_KEYS.CONTACT_ROLE] },
    },
  });

  const contactTableHeader = (
    <ResponsiveButton startIcon={<AddIcon />} onClick={handleCreateContact} variant="outlined">
      Add
    </ResponsiveButton>
  );

  const prefByUuid = useMemo(() => _.keyBy(preferenceData ?? [], 'uuid'), [preferenceData]);

  return (
    <AccordionSection
      title="Contacts"
      collapseId={UserSettingsCollapseKeys.ACCOUNT_ITEM_CONTACTS}
      headerElements={contactTableHeader}
      hasData={contacts.length > 0}
      scrollable
    >
      <TableContainer>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Role</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Email</TableCell>
              <TableCell>Phone</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.map((contact: Contact) => (
              <TableRow key={contact.uuid} sx={listPageTableRowStyling}>
                <TableCell>
                  <DrawerLink module={UserConfigurableModule.CONTACTS} uuid={contact.uuid}>{`${contact.first_name} ${contact.last_name}`}</DrawerLink>
                </TableCell>
                <TableCell>
                  <PreferencesPopover values={_.filter(_.map(contact.roles_uuids, uuid => prefByUuid[uuid]))} />
                </TableCell>
                <TableCell>{contact.contact_title_value}</TableCell>
                <TableCell>{contact.email}</TableCell>
                <TableCell>{contact.phone_1}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </AccordionSection>
  );
};

export default AccountContactTable;
